<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageUrl]="'/email-labeling-settings'"
        [previousPageTitle]="'ADMINISTRATION.EMAIL_LABELING_SETTINGS.TITLE' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>{{ displayTitle() }}</glxy-page-title>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="'wide'">
    <email-labeling-config
      [namespace]="namespace()"
      [userId]="userId()"
      [configId]="configId"
      [existingConfig]="existingConfig()"
      (saved)="onLabelsSaved($event)"
      (cancelled)="onCancelled()"
    >
    </email-labeling-config>
  </glxy-page-wrapper>
</glxy-page>
